import React, { useState } from "react";
import { InfoOutlined as InfoIcon } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/InfoOutlined";
import { CloseOutlined as CrossIcon } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/CloseOutlined";
import Form from "@JohnLewisPartnership/checkout-forms/dist/components/form-simple/Form";
import { TextInput } from "@JohnLewisPartnership/jl-design-system/dist/components/text-input/TextInput";

import styles from "./stock-tool-form.module.scss";

function StockToolForm({ noDetailsText = null, onSubmit = () => {} }) {
  const [infoMessageShown, setInfoMessageShown] = useState(false);

  const productCodeFormField = {
    component: TextInput,
    type: "text",
    name: "productCode",
    label: "Enter product code",
    id: "productCode",
    classname: "fieldLarge",
    required: true,
    maxLength: 8,
    regex: /^[0-9]{8}$/,
    validationMessageKeys: {
      required: "Please enter a product code",
      maxLength: "",
      regex: "Please enter a valid product code. They are 8 numerical characters in length, for example ‘28193001’",
    },
  };

  const handleInfoIconClicked = () => {
    setInfoMessageShown(!infoMessageShown);
  };

  const infoPanel = (
    <div className={styles["stockTool__info-panel"]}>
      A product code is typically located in the ‘product description’ section which is positioned under the product
      image. You can also press ‘ctrl f’ and type ‘product code’ to highlight it on the product page.
      <button type="button" onClick={handleInfoIconClicked}>
        <CrossIcon />
      </button>
    </div>
  );

  return (
    <div className={styles.stockTool}>
      <h3 className={styles.stockTool__question}>
        {!noDetailsText ? (
          <span>We can give you an update when we might have stock</span>
        ) : (
          <span>{noDetailsText}</span>
        )}
      </h3>
      <div className={styles.stockTool__info}>
        <span>Where can I find the product code?</span>
        <button type="button" className={styles["stockTool__info-button"]} onClick={handleInfoIconClicked}>
          <InfoIcon />
        </button>
      </div>
      <div className={styles["stockTool__info-wrapper"]}>{infoMessageShown ? infoPanel : null}</div>
      <div className={styles["stockTool__form-wrapper"]}>
        <Form fields={[productCodeFormField]} onSubmit={onSubmit} submitButton="Check stock" />
      </div>
    </div>
  );
}

export default StockToolForm;
